import { Injectable } from '@angular/core';
import { FormType } from '../rl-common/forms/shared/form-type.enum';
import { EntityType } from '../rl-common/shared/shared/entity-type.enum';
import { SidePanelService } from '../side-panel/core/side-panel.service';
import { EventPoolService } from './event-pool.service';
import { NgUserService } from './ng-user.service';
import { NgTagsService } from '../tags/core/ng-tags.service';
import { UtilsService } from '../rl-common/shared/core/utils.service';
import { LegantoEntity } from '../rl-common/shared/shared/types/leganto-entity';
import { BolkService } from '../requests/core/bolk.service';
import { ngListService } from '../list/core/ng-list.service';
import { DialogService } from '../rl-common/dialogs/core/dialog.service';
import { MarkAsBrokenServiceService } from '../mark-as-broken/mark-as-broken/mark-as-broken-service.service';

@Injectable({
  providedIn: 'root'
})
export class NgService {

  constructor(private sidePanel : SidePanelService, private userService : NgUserService, private eventPool : EventPoolService,  private tagsService : NgTagsService, private utilsService : UtilsService, private bolkService : BolkService,
    private listService : ngListService, private dialogService : DialogService, private markAsBrokenService : MarkAsBrokenServiceService)  { }

  openAddItem = (onAdd) => this.sidePanel.openAddNewItem(FormType.ASSIGNMENT, EntityType.ASSIGNMENT, onAdd[0]);

  initUser = (user) => this.userService.initUser(user[0]);
  initList = (list) =>this.listService.currentList = list[0];
  registerToSectionsChanges = (callback) => this.eventPool.sectionsListener$.subscribe(callback[0]);
  registerToTagsChanges = (callback) => this.eventPool.tagsListener$.subscribe(callback[0]);

  //a flag to use in angularjs
  ngOn : boolean = false;
  setNg = (isOn : boolean) => this.ngOn = isOn;
  isNgOn = () => this.ngOn;
   //a flag to use in angularjs
  ngAsideOn : boolean = false;
  setNgAsideOn              = (isNgAsideOn : boolean) => this.ngAsideOn = isNgAsideOn;
  isNgAsideOn               = () => this.ngAsideOn;
  getTagsToDisplay          = (params : [any[], string, boolean]) => this.tagsService.createTagsToDisplay(params[0], params[1], params[2]);
  getTags                   = (params :  [any, string, any]) => this.tagsService.get(EntityType[params[0]], params[1]).subscribe(params[2]);
  getLegantoEntity          = (entityTypeIdPair : [string, string]) => new LegantoEntity(<EntityType>entityTypeIdPair[0], entityTypeIdPair[1]);

  createBolkRequest         = (params) => this.bolkService.createBolkRequest(params[0]).subscribe(() => {params[1](true);});
  hasISBNApprovedRequests   = (params) => this.bolkService.hasISBNApprovedRequests(params[0]).subscribe((res) => {params[1](res);});
  getBolkUrlFile            = (params) => this.bolkService.getBolkUrlFile(params[0]).subscribe((res) => {params[1](res);});
  extendBolkRightsClearance = (params) => this.bolkService.extendBolkRightsClearance(params[0]).subscribe(() => {params[1](true);});

  acceptBolkRightsClearance = (params) => this.bolkService.acceptBolkRightsClearance(params[0]).subscribe(() => {params[1](true);});
  rejectBolkRightsClearance = (params) => this.bolkService.rejectBolkRightsClearance(params[0]).subscribe(() => {params[1](true);});
  lockBolkRequests          = (params) => this.bolkService.lockBolkRequests(params[0]).subscribe((res) => {params[1](res);});

  openQuickCiteDialog       = (params) => this.dialogService.openQuickCiteDialog(params[0]);
  openMarkAsBrokenDialog    = (params : [any, boolean, any, () => void]) => this.markAsBrokenService.openMarkAsBrokenDialog(params[0], params[1], params[2], params[3]);
  
}
